export const urls = {
    postImage: '/api/v2/images',
    deleteImage: imageId => `/api/users/image/${imageId}`
};

export const initialState = {
    data: {},
    isFetching: false,
    isError: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'REQUEST_IMAGES':
            return {
                data: {},
                isFetching: true,
                isError: false
            };
        case 'REMOVE_TEMPORAL_IMAGES':
        case 'RESPONSE_DELETE_IMAGES':
            return {
                data: {},
                isFetching: false,
                isError: false
            };
        case 'ERROR_POST_IMAGES':
            return {
                data: {},
                isFetching: false,
                isError: true
            };
        case 'RESPONSE_POST_IMAGES':
            return {
                data: action.data.data,
                isFetching: false,
                isError: false
            };
        default:
            return state;
    }
};
